import { isFallbackSiteData } from "@/utils/fallbackSiteData";

type SiteDataWithMetadata = {
  metadata?: {
    vwo?: unknown;
  };
};

export const getSiteHasExperiments = (siteDataFromApi: unknown): boolean => {
  if (!siteDataFromApi || typeof siteDataFromApi !== "object" || !("metadata" in siteDataFromApi)) {
    return false;
  }

  return Boolean((siteDataFromApi as SiteDataWithMetadata).metadata?.vwo);
};

// Only real API site data is persisted: a fallback (or empty) value would stick for the whole session
export const shouldPersistSiteData = (siteDataFromApi: unknown): boolean =>
  typeof siteDataFromApi === "object" &&
  siteDataFromApi !== null &&
  !isFallbackSiteData(siteDataFromApi);
